import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

function LocationDistance(_param) {
    var { className , distance , labels , timeByCar , timeByFoot  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "distance",
        "labels",
        "timeByCar",
        "timeByFoot"
    ]);
    const isEmpty = !(distance || timeByCar || timeByFoot);
    if (isEmpty) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: classnames('location-distance', className)
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "location-distance__content"
    }, distance && /*#__PURE__*/ React.createElement("div", {
        className: "location-distance__item"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "location-distance__text",
        component: "span",
        variant: "body-head"
    }, labels.distance)), timeByFoot && /*#__PURE__*/ React.createElement("div", {
        className: "location-distance__item"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "walking"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "location-distance__visually-hidden"
    }, labels.walking), /*#__PURE__*/ React.createElement(Text, {
        className: "location-distance__text",
        component: "span"
    }, timeByFoot)), timeByCar && /*#__PURE__*/ React.createElement("div", {
        className: "location-distance__item"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "driving"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "location-distance__visually-hidden"
    }, labels.driving), /*#__PURE__*/ React.createElement(Text, {
        className: "location-distance__text location-distance__text--space",
        component: "span"
    }, timeByCar))));
}
var LocationDistance$1 = /*#__PURE__*/ React.memo(LocationDistance);

export { LocationDistance$1 as default };
//# sourceMappingURL=LocationDistance.js.map
